module.exports = __webpack_public_path__ + "img/Picture7.9086e50a.png";